import { SET_SECONDARY_STATE, RESET_SECONDARY_STATE } from "../types/secondaryOrderTypes";

export interface SecondaryOrderReducerState {
    createNewOrderState: {
        outletId: string;
        diffShippingAddress: boolean;
    }
}

const initialState: SecondaryOrderReducerState = {
    createNewOrderState: {
        outletId: "",
        diffShippingAddress: false,
    },
};


const secondaryOrderReducer = (state = initialState, action: any): SecondaryOrderReducerState => {
    switch (action.type) {
        case SET_SECONDARY_STATE:
            return { ...state, createNewOrderState: action.payload };
        case RESET_SECONDARY_STATE:
            return initialState;
        default:
            return state;
    }
};

export default secondaryOrderReducer;
